import { Text } from "@aurem/ui";
import { Inbox } from "lucide-react";
import { useI18n } from "providers/I18nProvider";

export const NotificationEmpty = () => {
  const { t } = useI18n();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 py-20">
      <Inbox size="1.5rem" className="text-neutral-200" />
      <Text size="sm" className="text-center text-neutral-500/50">
        {t("apps.admin.notifications.empty")}
      </Text>
    </div>
  );
};
